/**
 * Which payslip the My Pay card shows.
 *
 * Extracted as a pure function (CLAUDE.md § "Component Testability": logic
 * out of the component, JSX + wiring in it) because the interesting case is
 * not the happy path — it is the STALE selection. `my_pay` is replaced
 * wholesale when the employer picker switches company, and grows a new
 * newest entry when a pay run is approved; in both cases a held id can name
 * a payslip that is no longer in this list. Resolving that to the latest
 * payslip, rather than to `undefined`, is what stops the card rendering
 * empty — and it is a one-line condition that no component test can reach
 * without remount plumbing.
 */
import type { MyPay, Payslip } from '../../data/types';

export function resolveSelectedPayslip(
  my_pay: MyPay,
  selected_payslip_id: string | null,
): Payslip {
  if (selected_payslip_id === null) return my_pay.current_payslip;
  return (
    my_pay.history.find((entry) => entry.id === selected_payslip_id) ??
    my_pay.current_payslip
  );
}
